import Axios from "@/plugins/Axios";

export class PlanosMensaisService {
  async planoMensal(gestaoDeAulaId, mes_id, disciplinaId) {
    const response = await Axios().get(
      `planos-mensais/plano-mensal/${gestaoDeAulaId}/${mes_id}/${disciplinaId}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-mensais/criar-plano-mensal`, {
      plano,
    });
    return response.data;
  }
}
export default new PlanosMensaisService();
